var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.625 42.75H47.5V35.625H42.75V42.75H35.625V47.5H42.75V54.625H47.5V47.5H54.625M14.25 4.75C12.9902 4.75 11.782 5.25044 10.8912 6.14124C10.0004 7.03204 9.5 8.24022 9.5 9.5V47.5C9.5 50.1362 11.6137 52.25 14.25 52.25H32.7988C31.9438 50.7775 31.35 49.1625 31.065 47.5H14.25V9.5H30.875V21.375H42.75V31.065C43.5337 30.9462 44.3413 30.875 45.125 30.875C45.9325 30.875 46.7163 30.9462 47.5 31.065V19L33.25 4.75M19 28.5V33.25H38V28.5M19 38V42.75H30.875V38H19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIconWhite);
export default __webpack_public_path__ + "static/media/documentIconWhite.bc3b36e4579f51a99d7ec1c6e1168e13.svg";
export { ForwardRef as ReactComponent };